import React from 'react'
export default function ErrorMessage(props) {
    return (
        <div className='no-record-avail'>
            <p className='noRecordErrorMesage'>{props.messageText}</p>
        </div>
    )
}
